function MultiLoginSwitchAccountLogout() {
  // Redirect to the LOGOUT url of the bcom site.
  globalThis.location.href = `${process.env.REACT_APP_BCOM_LOGOUT_URL}`
  return null
}

export default MultiLoginSwitchAccountLogout
